export default __webpack_public_path__ + "static/media/research-table-2.dbfff554.png";